import React, {
useEffect,
useState
} from "react";

import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";

function Dashboard() {

const [stats, setStats] = useState({
volunteers: 0,
donations: 0,
totebags: 0,
feedbacks: 0
});

const [volunteers, setVolunteers] =
useState([]);

const [donations, setDonations] =
useState([]);

const [totebags, setTotebags] =
useState([]);

const [search, setSearch] =
useState("");

const [feedbacks, setFeedbacks] =
useState([]);

const token =
localStorage.getItem(
"ekyaAdminToken"
);

useEffect(() => {


fetchDashboardData();

}, []);

const fetchDashboardData =
async () => {


  try {

    const config = {
      headers: {
        Authorization:
          `Bearer ${token}`
      }
    };

    const statsRes =
      await axios.get(
        "https://ekya-backend.onrender.com/api/admin/stats",
        config
      );

    const volunteerRes =
      await axios.get(
        "https://ekya-backend.onrender.com/api/admin/volunteers",
        config
      );

    const donationRes =
      await axios.get(
        "https://ekya-backend.onrender.com/api/admin/donations",
        config
      );

    const toteRes =
      await axios.get(
        "https://ekya-backend.onrender.com/api/admin/totebags",
        config
      );
      const feedbackRes =
     await axios.get(
    "https://ekya-backend.onrender.com/api/admin/feedback",
    config
  );

    setStats(
      statsRes.data
    );

    setVolunteers(
      volunteerRes.data.volunteers
    );

    setDonations(
      donationRes.data.donations
    );

    setTotebags(
      toteRes.data.totebags
    );
    setFeedbacks(
  feedbackRes.data.feedbacks
);

  } catch (error) {

    Swal.fire({
      icon: "error",
      title:
        "Access Denied",
      text:
        "Please login again."
    });

  }

};


const deleteItem =
async (
type,
id
) => {


  const result =
    await Swal.fire({
      title:
        "Delete Record?",
      text:
        "This action cannot be undone.",
      icon:
        "warning",
      showCancelButton:
        true,
      confirmButtonText:
        "Delete"
    });

  if (
    !result.isConfirmed
  ) {
    return;
  }

  try {

    await axios.delete(
      `https://ekya-backend.onrender.com/api/admin/${type}/${id}`,
      {
        headers: {
          Authorization:
            `Bearer ${token}`
        }
      }
    );

    Swal.fire({
      icon:
        "success",
      title:
        "Deleted Successfully"
    });

    fetchDashboardData();

  } catch (error) {

    Swal.fire({
      icon:
        "error",
      title:
        "Delete Failed",
      text:
        error.response?.data?.message ||
        "Something went wrong"
    });

  }

};


const logoutHandler =
() => {


  localStorage.removeItem(
    "ekyaAdminToken"
  );

  window.location.href =
    "/admin";

};


const filteredVolunteers =
volunteers.filter(
(v) =>
v.fullName
?.toLowerCase()
.includes(
search.toLowerCase()
)
);

const filteredDonations =
donations.filter(
(d) =>
d.name
?.toLowerCase()
.includes(
search.toLowerCase()
)
);

const filteredTotebags =
totebags.filter(
(t) =>
t.fullName
?.toLowerCase()
.includes(
search.toLowerCase()
)
);
const filteredFeedbacks =
feedbacks.filter(
(f)=>

f.fullName
?.toLowerCase()
.includes(
search.toLowerCase()
)

);
return (


<div
  className="
    min-h-screen
    bg-[#F8F5F0]
    p-6
  "
>

  <motion.div
    initial={{
      opacity: 0,
      y: -20
    }}
    animate={{
      opacity: 1,
      y: 0
    }}
    className="
      bg-white
      rounded-3xl
      p-8
      shadow-xl
      mb-8
    "
  >

    <div
      className="
        flex
        flex-col
        md:flex-row
        justify-between
        items-center
        gap-4
      "
    >

      <div>

        <h1
          className="
            text-4xl
            font-bold
          "
        >
          Welcome Back 👋
        </h1>

        <p
          className="
            text-gray-500
            mt-2
          "
        >
          Manage volunteers,
          donations and
          tote bookings.
        </p>

      </div>

      <button
        onClick={
          logoutHandler
        }
        className="
          bg-black
          text-white
          px-6
          py-3
          rounded-2xl
          hover:scale-105
          transition
        "
      >
        Logout
      </button>

    </div>

  </motion.div>

  <input
    type="text"
    placeholder="Search records..."
    value={search}
    onChange={(e) =>
      setSearch(
        e.target.value
      )
    }
    className="
      w-full
      bg-white
      rounded-2xl
      p-4
      shadow-md
      mb-8
      outline-none
    "
  />

  <div
    className="
      grid
      md:grid-cols-3
      gap-6
      mb-12
    "
  >

    <motion.div
      whileHover={{
        y: -8,
        scale: 1.03
      }}
      className="
        bg-white
        rounded-3xl
        p-6
        shadow-lg
      "
    >

      <div
        className="
          text-5xl
          mb-4
        "
      >
        👥
      </div>

      <h2
        className="
          text-gray-500
        "
      >
        Volunteers
      </h2>

      <p
        className="
          text-5xl
          font-bold
          mt-3
        "
      >
        {stats.volunteers}
      </p>

    </motion.div>

    <motion.div
      whileHover={{
        y: -8,
        scale: 1.03
      }}
      className="
        bg-white
        rounded-3xl
        p-6
        shadow-lg
      "
    >

      <div
        className="
          text-5xl
          mb-4
        "
      >
        💝
      </div>

      <h2
        className="
          text-gray-500
        "
      >
        Donations
      </h2>

      <p
        className="
          text-5xl
          font-bold
          mt-3
        "
      >
        {stats.donations}
      </p>

    </motion.div>

    <motion.div
      whileHover={{
        y: -8,
        scale: 1.03
      }}
      className="
        bg-white
        rounded-3xl
        p-6
        shadow-lg
      "
    >

      <div
        className="
          text-5xl
          mb-4
        "
      >
        👜
      </div>

      <h2
        className="
          text-gray-500
        "
      >
        Tote Bookings
      </h2>

      <p
        className="
          text-5xl
          font-bold
          mt-3
        "
      >
        {stats.totebags}
      </p>

    </motion.div>


  </div>

  <h2
    className="
      text-3xl
      font-bold
      mb-6
    "
  >
    Volunteers
  </h2>

  <div
    className="
      grid
      md:grid-cols-2
      xl:grid-cols-3
      gap-6
      mb-16
    "
  >

    {filteredVolunteers.length > 0 ? (

      filteredVolunteers.map(
        (v) => (

          <motion.div
            key={v._id}
            whileHover={{
              y: -8
            }}
            className="
              bg-white
              rounded-3xl
              p-6
              shadow-lg
            "
          >

            <div className="text-4xl mb-4">
              👤
            </div>

            <h3 className="font-bold text-xl">
              {v.fullName}
            </h3>

            <p className="text-gray-500">
              {v.email}
            </p>

            <p className="mt-2">
              📍 {v.city}
            </p>

            <p>
              📞 {v.phone}
            </p>

            <button
              onClick={() =>
                deleteItem(
                  "volunteers",
                  v._id
                )
              }
              className="
                mt-4
                w-full
                py-3
                rounded-xl
                bg-red-500
                text-white
              "
            >
              Delete
            </button>

          </motion.div>

        )
      )

    ) : (

      <div
        className="
          bg-white
          rounded-3xl
          p-10
          text-center
          col-span-full
        "
      >
        No Volunteers Found
      </div>

    )}

  </div>

  <h2
    className="
      text-3xl
      font-bold
      mb-6
    "
  >
    Donations
  </h2>

  <div
    className="
      grid
      md:grid-cols-2
      xl:grid-cols-3
      gap-6
      mb-16
    "
  >

    {filteredDonations.length > 0 ? (

      filteredDonations.map(
        (d) => (

          <motion.div
            key={d._id}
            whileHover={{
              y: -8
            }}
            className="
              bg-white
              rounded-3xl
              p-6
              shadow-lg
            "
          >

            <div className="text-4xl mb-4">
              💝
            </div>

            <h3 className="font-bold text-xl">
              {d.name}
            </h3>

            <p className="text-3xl font-bold mt-2">
              ₹{d.amount}
            </p>

            <p className="mt-3">
              📞 {d.phone}
            </p>

            <p className="text-gray-500">
              {d.email}
            </p>

            <button
              onClick={() =>
                deleteItem(
                  "donations",
                  d._id
                )
              }
              className="
                mt-4
                w-full
                py-3
                rounded-xl
                bg-red-500
                text-white
              "
            >
              Delete
            </button>

          </motion.div>

        )
      )

    ) : (

    <div
  className="
    bg-white
    rounded-3xl
    p-10
    text-center
    col-span-full
  "
>
  No Donations Found
</div>

    )}  

  </div>

  <h2
    className="
      text-3xl
      font-bold
      mb-6
    ">
    Tote Bag Bookings
  </h2>

  <div
    className="
      grid
      md:grid-cols-2
      xl:grid-cols-3
      gap-6
    "
  >

    {filteredTotebags.length > 0 ? (

      filteredTotebags.map(
        (t) => (

          <motion.div
            key={t._id}
            whileHover={{
              y: -8
            }}
            className="
              bg-white
              rounded-3xl
              p-6
              shadow-lg
            "
          >

            <div className="text-4xl mb-4">
              👜
            </div>

            <h3 className="font-bold text-xl">
              {t.fullName}
            </h3>

            <p>
              📞 {t.phone}
            </p>

            <p>
              📍 {t.city}
            </p>

            <p className="mt-2 font-semibold">
              Quantity: {t.quantity}
            </p>

            <p className="text-gray-500 mt-2">
              {t.email}
            </p>

            <button
              onClick={() =>
                deleteItem(
                  "totebags",
                  t._id
                )
              }
              className="
                mt-4
                w-full
                py-3
                rounded-xl
                bg-red-500
                text-white
              "
            >
              Delete
            </button>

          </motion.div>

        )
      )
      

    ) : (

      <div
        className="
          bg-white
          rounded-3xl
          p-10
          text-center
          col-span-full
        "
      >
        No Tote Bookings Found
      </div>

    )}

  </div>
  <h2
className="
text-3xl
font-bold
mb-6
mt-16
"
>
⭐ Feedback
</h2>

<div
className="
grid
md:grid-cols-2
xl:grid-cols-3
gap-6
"
>

{

filteredFeedbacks.length>0 ?

(

filteredFeedbacks.map((f)=>(

<motion.div

key={f._id}

whileHover={{
y:-8
}}

className="
bg-white
rounded-3xl
p-6
shadow-lg
"

>

<div className="text-4xl mb-4">
⭐
</div>

<h3 className="font-bold text-xl">
{f.fullName}
</h3>

<p className="text-gray-500">
{f.email}
</p>

<p className="mt-3">
📞 {f.phone || "-"}
</p>

<p className="mt-2 font-semibold">
{f.subject}
</p>

<p className="mt-2 text-gray-600">
{f.message}
</p>

<div className="mt-3 text-yellow-500 text-xl">
{"⭐".repeat(f.rating)}
</div>

<button

onClick={()=>
deleteItem(
"feedback",
f._id
)
}

className="
mt-5
w-full
py-3
rounded-xl
bg-red-500
text-white
hover:bg-red-600
transition
"

>

Delete

</button>

</motion.div>

))

)

:

(

<div
className="
bg-white
rounded-3xl
p-10
text-center
col-span-full
"
>

No Feedback Found

</div>

)

}

</div>

</div>


);

}

export default Dashboard;
